"use client"

import { GetJobsQuery, GetPageByRouteQuery } from "@eurodrive/apollo"
import { BlockRenderer } from "@eurodrive/ui"
import { getBreadCrumbs, transformProperties } from "@eurodrive/utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  jobs: GetJobsQuery
}

// Define the components mapping object based on the block types from the query
const components = {
  heroBannerInnerPages: () => import("@eurodrive/ui/Banner"),
  reasonsWhy: () => import("@eurodrive/ui/ReasonsWhy"),
  jobsTitle: () => import("./JobsTitle"),
}

export default function Careers({ data, locale, jobs }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)

  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        let blockProps
        if (block.blockType === "heroBannerInnerPages") {
          blockProps =
            locale === "he" ? { compact: true, breadCrumbs } : { compact: true }
        }
        if (block.blockType === "jobsTitle") {
          blockProps = { jobs }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={blockProps}
          />
        )
      })}
    </>
  )
}
